import TitleHelmet from 'components/TitleHelmet'
import { PageTitle } from 'utils/constants/pageTitles'

const MessageFlow = () => {
  return (
    <>
      <TitleHelmet title={PageTitle.COURSE_SETUP_MESSAGE_FLOW} />
      <h1>{PageTitle.COURSE_SETUP_MESSAGE_FLOW}</h1>
    </>
  )
}

export default MessageFlow
